import * as React from 'react';
import * as _ from 'lodash';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import ApiEndpoints from '../../config/apiendpoints';
import InventoryPhotoGallery from '../gallery';
import { Formatters } from '../../common/formatters';

// Default Inventory thumbnail shown when picture path is empty
export const DefaultPictureNotSelectedUrl: string = '/Photos/no-photo-selected.png';
export const DefaultPictureNotFoundUrl: string = '/Photos/photo-not-found.png';

export const InventoryDetailFormComponentDetailsPictures = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,
    formData,
    defaultInputProps,
    sectionTitle,
    handlePictureSelect,
    handlePictureClear,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    const getPictureText = (index, name, path) => {
        return `${appText('picture')} ${index + 1}: ${name} (${path})`;
    };

    let formDataImages = _.stubArray();

    let pic1 = Formatters.getStr(formData, 'picture1') || DefaultPictureNotSelectedUrl;
    formDataImages.push(pic1);

    let pic2 = Formatters.getStr(formData, 'picture2') || DefaultPictureNotSelectedUrl;
    formDataImages.push(pic2);

    const inventoryPictureImages = formDataImages.map((picPath, ind) => {
        let thumbnailUrl = (picPath) ?
            ApiEndpoints.getInventoryPictureUrl(picPath, true) :
            ApiEndpoints.getInventoryPictureUrl(DefaultPictureNotSelectedUrl, true);

        return {
            id: ind,
            src: ApiEndpoints.getInventoryPictureUrl(picPath, false),
            thumbnail: thumbnailUrl,
            thumbnailFallback: ApiEndpoints.getInventoryPictureUrl(DefaultPictureNotFoundUrl, true),

            caption: getPictureText(ind, _.get(formData, 'componentCustomName', ''), picPath),
            orientation: 'square',
            title: appText('picture') + ` ${ind + 1}`,
            fieldName: `picture${ind + 1}`,
            emptyPath: (!picPath || picPath === DefaultPictureNotSelectedUrl)
        };
    });

    const hidePictures = false; // true; // _.get(formData, 'hidePictures', false)
    const inventorySelectedPicturesGallery = (!hidePictures) ? (
        <InventoryPhotoGallery
            images={inventoryPictureImages}
            selectLinkCaption={appText('links.select')}
            clearLinkCaption={appText('links.clear')}
            onSelectLinkClick={(e, o) => { handlePictureSelect(e, o.fieldName); }}
            onClearLinkClick={(e, o) => { handlePictureClear(e, o.fieldName); }}
        />
    ) : (<div />);

    const inventorySelectedPicturesForm = (hidePictures) ? (
        <div>
            <div>
                <KendoWrappers.KendoTextInput
                    name="picture1"
                    label={`${appText('picture')} 1 ${appText('path')}`}
                    value={formData.picture1}
                    {...inputPropsFullWidth}
                />
            </div>

            <div>
                <KendoWrappers.KendoTextInput
                    name="picture2"
                    label={`${appText('picture')} 2 ${appText('path')}`}
                    value={formData.picture2}
                    {...inputPropsFullWidth}
                />
            </div>
        </div>
    ) : (<div />);

    return (
        <DetailFormCommon.InventoryDetailFormSection title={sectionTitle}>
            {/* <div>
                <KendoWrappers.KendoCheckbox
                    name="hidePictures"
                    label={appText('links.hide-images')}
                    value={formData.hidePictures}
                    {...inputProps}
                />
            </div> */}

            <div className="inventory-detail-selected-pictures">
                {inventorySelectedPicturesGallery}
            </div>

            <div className="inventory-detail-selected-pictures-form">
                {inventorySelectedPicturesForm}
            </div>
        </DetailFormCommon.InventoryDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/inventory/detail-form/component-details-pictures.tsx